import { render } from "./CardDoughnutChart.vue?vue&type=template&id=0540c43b"
import script from "./CardDoughnutChart.vue?vue&type=script&lang=js"
export * from "./CardDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__